module.exports = __webpack_public_path__ + "static/media/costcase6.65055c21.png";